import { MAX_AGE_MINUTES } from './synoptic';
import type { Station } from './types';

/** Stations kept at most; the oldest observations go first. */
const MAX_CACHED = 5000;

/** Adds fresh stations to the cache and drops observations that became too old. */
export function mergeStations(
  cache: ReadonlyMap<string, Station>,
  fresh: readonly Station[],
  now: number,
): Map<string, Station> {
  const minTime = now - MAX_AGE_MINUTES * 60_000;
  const merged = new Map([...cache].filter(([, s]) => s.time >= minTime));
  for (const s of fresh) if (s.time >= minTime) merged.set(s.id, s);
  if (merged.size <= MAX_CACHED) return merged;
  const newest = [...merged.values()].sort((a, b) => b.time - a.time).slice(0, MAX_CACHED);
  return new Map(newest.map((s) => [s.id, s]));
}
